import React, { useState } from "react";
import styled from "styled-components";

const faqData = [
  {
    category: "General",
    items: [
      {
        question: "What is ceramic sanitary ware?",
        answer: (
          <div>
            Ceramic sanitary ware includes:
            <ul>
              <li>Toilets</li>
              <li>Wash Basins</li>
              <li>Urinals</li>
              <li>Cisterns</li>
              <li>Squatting Pans</li>
            </ul>
            Made from high-quality fired clay. They are durable, hygienic, and easy to maintain.
          </div>
        ),
      },
      {
        question: "What is vitreous china?",
        answer: (
          <div>
            Vitreous china is ceramic coated with:
            <ul>
              <li>Smooth, glass-like enamel</li>
              <li>Non-porous surface</li>
              <li>Stain-resistant finish</li>
            </ul>
          </div>
        ),
      },
      {
        question: "Why choose ceramic sanitary ware?",
        answer: (
          <ul>
            <li>Durable</li>
            <li>Easy to clean</li>
            <li>Resistant to stains and chemicals</li>
            <li>Provides a hygienic surface</li>
          </ul>
        ),
      },
      {
        question: "What products are included in ceramic sanitaryware?",
        answer: (
          <ul>
            <li>Toilet seats (WC)</li>
            <li>Wash basins</li>
            <li>Squatting (Indian) pans</li>
            <li>Urinals</li>
          </ul>
        ),
      },
      {
        question: "What is the difference between Western toilet and squatting pan?",
        answer: (
          <ul>
            <li><strong>Western Toilet (WC):</strong> Used in a sitting position</li>
            <li><strong>Squatting Pan:</strong> Used in a squatting position (common in India)</li>
          </ul>
        ),
      },
    ],
  },
  {
    category: "Toilets (EWC)",
    items: [
      {
        question: "What is an EWC?",
        answer: (
          <div>
            <strong>EWC (European Water Closet)</strong> is a western-style sitting toilet designed for comfort.
          </div>
        ),
      },
      {
        question: "Type of Toilets?",
        answer: (
          <div>
            <strong>Toilet Type depends on Installation/ Mounting</strong>
            <ul>
              <li>One Piece </li>
              <li>Two Piece - Close-Coupled </li>
              <li>EWC / Commande</li>
              <li>Wall Hung </li>
              </ul>            
          </div>
        ),
      },
      {
        question: "What is difference between Syphonic and washdown toilet?",
        answer: (
          <div>
            <strong>Siphonic Toilet</strong>
            <ul>
              <li>Uses a siphon action (vacuum effect) to pull waste out.</li>
              <li>Water fills the bowl and then creates a suction that empties it smoothly.</li>
              <li>Uses more water.</li>
              <li>Larger water surface → better odor control.</li>
              <li>Less chance of clogging (due to suction).</li>
              <li>Common in USA & some premium setups.</li>
            </ul>

            <strong>Washdown Toilet</strong>
            <ul>
              <li>Uses gravity + direct water force to push waste down the trap.</li>
              <li>No siphon effect, just a strong flush pushing waste out.</li>
              <li>Uses less water (more efficient).</li>
              <li>Smaller water surface.</li>
              <li>Slightly higher chance of clogging if not designed well.</li>
              <li>Common in India, Europe, and Asia.</li>
            </ul>
          </div>
        ),
      },
      {
        question: "What is the difference between S-trap and P-trap?",
        answer: (
          <ul>
            <li><strong>S-trap:</strong> Connects through the floor</li>
            <li><strong>P-trap:</strong> Connects through the wall</li>
          </ul>
        ),
      },
      {
        question: "How much water does a toilet use?",
        answer: (
          <ul>
            <li>Modern dual-flush toilets use about:</li>
            <li>3 liters (half flush)</li>
            <li>6 liters (full flush)</li>
          </ul>
        ),
      },
    ],
  },
  {
    category: "Wash Basins",
    items: [
      {
        question: "What types of Wash Basins are available?",
        answer: (
          <ul>
            <li>Wall-mounted</li>
            <li>Table Top</li>
            <li>Countertop</li>
            <li>Under-counter</li>
            <li>Full Pedestal</li>
            <li>Half/Semi-Pedestal Basins</li>
          </ul>
        ),
      },
      {
        question: "Which wash basin is best for small bathrooms?",
        answer: (
          <div>
            <strong>Wall-mounted</strong> or <strong>compact basins</strong> are ideal for small spaces.
          </div>
        ),
      },
    ],
  },
  {
    category: "Squatting Pans",
    items: [
      {
        question: "What is a Squatting Pan?",
        answer: (
          <div>
            A floor-level toilet used in a squatting position, commonly used in India and Middle East & Africa.
          </div>
        ),
      },
      {
        question: "What are the advantages?",
        answer: (
          <ul>
            <li>More hygienic</li>
            <li>Cost-effective</li>
            <li>Durable</li>
            <li>Easy to maintain</li>
          </ul>
        ),
      },
       {
        question: "Type of Squatting Pan?",
        answer: (
          <div>
            <strong>Depends on Size and Shapes</strong>
            <ul>
              <li>Cello - low depth</li>
              <li>Full Deep </li>
              <li>Medium Deep</li>
              </ul>            
          </div>
        ),
      },
    ],
  },
  {
    category: "Urinals",
    items: [
      {
        question: "What types of urinals are available?",
        answer: (
          <ul>
            <li>Wall-Hung </li>
            <li>Sensor-based</li>
            <li>Manual flush urinals</li>
            <li> Outlet - Bottom or Back to Wall</li>
          </ul>
        ),
      },
      {
        question: "Are sensor urinals better?",
        answer: (
          <ul>
            <li>Improve hygiene</li>
            <li>Reduce water usage</li>
            <li>Minimize odor</li>
          </ul>
        ),
      },
    ],
  },
  {
    category: "Cleaning & Maintenance",
    items: [
      {
        question: "How do I clean ceramic sanitary ware?",
        answer: (
          <ul>
            <li>Use mild cleaners with a soft cloth</li>
            <li>Avoid abrasive materials</li>
          </ul>
        ),
      },
      {
        question: "How to remove tough stains?",
        answer: (
          <ul>
            <li>Use vinegar or mild descaling solution</li>
            <li>Avoid strong acids</li>
          </ul>
        ),
      },
    ],
  },
];


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  let count = 0;

  return (
    <Wrapper>
     <div className='container'>
      <h2>Frequently Asked Questions</h2>

  {faqData.map((section, i) => (
  <div key={i} className="section">
    <h3 className="category">{section.category}</h3>

    <ul className="list">
      {section.items.map((item, j) => {
        const index = count++;
        const isOpen = activeIndex === index;

        return (
          <li key={j} className="card">
            <div className="qa-block">
              <div className="question">{item.question}
                <button
                className="toggle"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
              >
                <span>{activeIndex === index ? "-" : "+"}</span>                
              </button>
              </div>
              

              {isOpen && (
                <div className="answerWrapper answerWrapperOpen">
                  <div className="answer">{item.answer}</div>
                </div>
              )}

              
            </div>
          </li>
        );
      })}
    </ul>
  </div>
))}
   
    </div>
    </Wrapper>
  );
};

  const Wrapper = styled.section`
 
  background: ${({ theme }) => theme.colors.bgl};
  min-height: 100vh;
  padding: 40px 20px;
  
  .container {
    max-width: 800px;
    margin: auto;    
    padding: 20px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(22, 15, 15, 0.08);
    margin-top: 3rem;
    }

  .title {
    margin-bottom: 20px;
    font-size: 3rem;
    }

  .section {
    margin-bottom: 20px;
    }

  .category {
    background: #DCE5DF;
    padding: 10px;
    border-radius: 5px;
    }

  .list {
    padding-left: 20px;
    list-style-type: disc;
    }

  .card {
    font-size: 1.5rem;
    }

  .question {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-weight: bold;
    margin-right: 30px;
    margin-top: 10px;
    }

  .answer {
    background: #F4F7F5;
    padding: 5px;
    border-radius: 8px;
    }

  .answer ul {
    list-style-type: disc;
    padding-left: 20px;
    margin-top: 5px;
    }

  .answerWrapper {
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.4s ease;
    max-height: 0;
    opacity: 0;
    }

  .answerWrapperOpen {
    max-height: 500px;
    opacity: 1;
    }
  
  .container h2 {
    text-align: center;
    margin-bottom: 20px;
    font-size: 2.5rem;
    }

  .toggle {
    align-self: flex-end;
    background: none;
    border: none;
    color:${({ theme }) => theme.colors.bgd};
    font-weight: bold;
    cursor: pointer;
    leftmargin: 3rem;
    }
  `;
export default FAQ;